<div class="spinner-container">
  <mat-progress-spinner class="spinner"
                        [color]="'primary'"
                        [mode]="'indeterminate'"
                        diameter="50">
  </mat-progress-spinner>
</div>
